import { CommonActionType } from './action.type';

export const CommonMutations = {
    [CommonActionType.SetExchangeRate](state, rate) {
        state.rate = rate;
    },

    [CommonActionType.SetMinFeeBuy](state, minFeeBuy) {
        state.minFeeBuy = minFeeBuy;
    },

    [CommonActionType.FeeBuyPro](state, feeBuyPro) {
        state.feeBuyPro = feeBuyPro;
    },

    [CommonActionType.SetCustomerLevels](state, customerLevels) {
        state.customerLevels = customerLevels;
    },

    [CommonActionType.SetWarehouse](state, warehouse) {
        state.warehouse = warehouse;
    },

    [CommonActionType.SetShippingMethod](state, shippingMethod) {
        state.shippingMethod = shippingMethod;
    },

    [CommonActionType.ShowHideMenuLeft](state, isShowHideMenuLeft) {
        state.showMenuLeft = isShowHideMenuLeft;
    },
};
